export default class SentryLog {
    constructor(props) {
        this.Sentry = null;
        this.dsn = "";
        this.getSentry = async () => {
            if (!this.Sentry) {
                const Sentry = await import("@sentry/nextjs");
                this.Sentry = Sentry;
                this.Sentry.init({
                    dsn: this.dsn,
                });
                return this.Sentry;
            }
            else {
                return this.Sentry;
            }
        };
        this.isNetworkError = (err) => err instanceof TypeError &&
            /The internet connection appears to be offline|Failed to fetch|Load failed|Network request failed|NetworkError when attempting to fetch resource|The network connection was lost/i.test(err.message);
        this.isAbortError = (err) => err instanceof Error && err.name == "AbortError";
        this.logError = async (error) => {
            const Sentry = await this.getSentry();
            if (!!Sentry) {
                const isInfoMessage = typeof error === "string" && error.length > 0;
                if (isInfoMessage ||
                    this.isNetworkError(error) ||
                    this.isAbortError(error) ||
                    !(error instanceof Error)) {
                    return;
                }
                Sentry === null || Sentry === void 0 ? void 0 : Sentry.captureException(error);
            }
        };
        this.withScopeAdded = async (error, errorInfo) => {
            const Sentry = await this.getSentry();
            Sentry.withScope((scope) => {
                Object.entries(errorInfo).map(([key, value]) => {
                    scope.setExtra(key, value);
                });
                this.logError(error);
            });
        };
        this.dsn = props.dsn;
    }
}
